import { render, staticRenderFns } from "./CustomTranslationDlg.vue?vue&type=template&id=8c27768a&scoped=true&"
import script from "./CustomTranslationDlg.vue?vue&type=script&lang=ts&"
export * from "./CustomTranslationDlg.vue?vue&type=script&lang=ts&"
import style0 from "./CustomTranslationDlg.vue?vue&type=style&index=0&id=8c27768a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c27768a",
  null
  
)

export default component.exports